<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
            <el-form-item label="提货单号:" prop="billNo">
              <el-input  placeholder="" v-model="searchFrom.billNo"></el-input>
            </el-form-item>
            <el-form-item label="出库单号:" prop="outBillNo" v-if="tableArr[0]">
              <el-input  placeholder="" v-model="searchFrom.outBillNo"></el-input>
            </el-form-item>
            <el-form-item label="提单状态 :" prop="status">
              <el-select v-model="searchFrom.status" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="待提交" value="1001" ></el-option>
                <el-option  label="审批中" value="1011" ></el-option>
                <el-option  label="审批驳回" value="1012" ></el-option>
                <el-option  label="下发失败" value="1021" ></el-option>
                <el-option  label="待提货" value="1031" ></el-option>
                <el-option  label="提货中" value="1041" ></el-option>
                 <el-option  label="提货完成" value="1042" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网络货运 :" prop="publishStatus">
              <el-select v-model="searchFrom.publishStatus" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="未发布" value="1" ></el-option>
                <el-option  label="已发布" value="2" ></el-option>
                <el-option  label="不发布" value="3" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算方式:" prop="feeModeType"  >
              <el-select v-model="searchFrom.feeModeType" placeholder="请选择" value-key="item_no" >
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="无" :value="-1" ></el-option>
                <el-option v-for="item in jsfsList" :key="item.item_no" :label="item.show_name" :value="item.item_no" ></el-option>
              </el-select>
          </el-form-item>
            <el-form-item label="提单来源 :" prop="billSource">
              <el-select v-model="searchFrom.billSource" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="库存提货" value="1" ></el-option>
                <!-- <el-option  label="表格导入" value="2" ></el-option> -->
                <el-option  label="外部接口" value="3" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库企业:" prop="organizationName" v-if="isCutCrm3!=1">
              <el-input  placeholder="" v-model="searchFrom.organizationName"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="004P00EB001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border row-key="id"
       lazy :load="load"  :row-class-name="tableRowClassName" :key="symbolKey"
       :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column   prop="date" width="50" label=""></el-table-column>
         <el-table-column label="序号" width="55">
          <template slot-scope="scope">
            <span v-if="scope.row.parentId==0">{{scope.row.parentIndex}}</span>
             <span v-else>-</span>
          </template>
        </el-table-column>

        <!-- <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column> -->
         <el-table-column label="操作"  width="180">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="004P00EB002" v-if="(scope.row.status==1031||scope.row.status==1041)&&btnFlg[1]&&scope.row.isSplit==1"  @click="rencheFn(scope.row)">人车</el-button>
              <el-button type="text" size="mini" btnCode="004P00EB003" v-if="((scope.row.auditStatus==2&&scope.row.publishStatus==1)||(scope.row.status==1031&&scope.row.publishStatus==1&&scope.row.auditStatus==1))&&btnFlg[2]&&scope.row.isSplit==1"   @click="publishFn(scope.row)">发布</el-button>
              <!-- <el-button type="text" size="mini" btnCode="004P00EB004" v-if="scope.row.status==1012&&scope.row.billSource!=3&&btnFlg[3]&&scope.row.isSplit==1"   @click="delFn(scope.row,'删除')">删除</el-button> -->
              <el-button type="text" size="mini" btnCode="004P00EB005"  v-if="(scope.row.status==1001&&scope.row.billSource!=2)&&btnFlg[4]&&scope.row.isSplit==1"   @click="submitFn(scope.row)">提货</el-button>
              <el-button type="text" size="mini" btnCode="004P00EB002" v-if="(scope.row.status==1001&&scope.row.billSource==3)&&btnFlg[5]&&scope.row.isSplit==1"  @click="zhuanhuoFn(scope.row)">转货</el-button>
              <el-button type="text" size="mini" btnCode="004P00EB002" v-if="scope.row.status==1001&&btnFlg[6]"  @click="editFN(scope.row)">编辑</el-button>
              <!-- 删除情况太复杂，所以写了两个按钮 -->
              <el-button type="text" size="mini" btnCode="004P00EB003"  v-if="(scope.row.status==1001&&scope.row.billSource!=3&&scope.row.publishStatus!=2)&&btnFlg[3]&&scope.row.isSplit==1&&scope.row.parentId==0"   @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" btnCode="004P00EB003"  v-if="(scope.row.status==1001||scope.row.status==1012)&&btnFlg[3]&&scope.row.publishStatus!=2&&scope.row.parentId!=0"   @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" btnCode="004P00EB002" v-if="scope.row.status==1031&&btnFlg[7]&&scope.row.isSplit==1"  @click="recallFn(scope.row)">撤回</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="提货单号" width="260">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.billNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提货函"  width="80">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="scope.row.isSplit==1" @click="lookFn(scope.row)">查看</el-button>
                <span v-else>-</span>
                <!-- <el-button type="text" size="mini" v-if="scope.row.templateCode=='0101'" @click="lookFn(scope.row)">{{scope.row.status!=1001?'查看':'编辑'}}</el-button> -->
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="outBillNo"  min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="出库单号"></el-table-column>
         <el-table-column width="120" property="status" :formatter="statusFormat" label="提单状态"></el-table-column>
        <el-table-column property="allWeight" width="120" :formatter="emptyFn" label="重量(吨)"></el-table-column>
        <el-table-column property="productNum" width="120" :formatter="emptyFn" label="件数"></el-table-column>
        <el-table-column prop="organizationName" :formatter="emptyFn" width="260" label="仓库企业"></el-table-column>
         <el-table-column property="publishStatus" label="网络货运">
          <template scope="scope">
            <span>{{["未发布", "已发布", "不发布",][scope.row.publishStatus-1]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="billSource" label="提单来源">
          <template scope="scope">
            <span>{{["库存提货", "表格导入", "外部接口",][scope.row.billSource-1]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="billSource" label="结算方式">
          <template scope="scope">
            <div>
              <span v-if="scope.row.feeModeType">{{["现结", "月结"][scope.row.feeModeType-1]}}</span>
              <span v-else>无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 提货函0101青岛钢业通用模板 -->
    <el-dialog title="提货函" :close-on-click-modal="false"  @close="closeDialog" :close-on-press-escape="false" :visible.sync="dialogTHH" width="900px" center>
      <div class="tihuohan" >
        <h3>{{billData.deliverCompany}}</h3>
        <h3>提货函</h3>
        <ul class="Q0101">
          <li>
            <div>提货仓库：{{billData.organizationName}}&nbsp;&nbsp;&nbsp;&nbsp;您好， 我司预提以下材料请给予办理为盼！</div>
            <div>提货单号：{{billData.billNo}}</div>
          </li>
          <li v-if="tableArr[0]">
             <div>出库单号：{{billData.outBillNo}}</div>
          </li>
           <li>
            <div>提货方式：{{['委托','自提'][billData.isEntrust-1]}}</div>
            <div>提货单位：{{billData.pickUpUnit}}</div>
          </li>
        </ul>
        <table border="1" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <td>捆包号</td>
              <td>材质</td>
              <td>规格</td>
              <td>表面质量</td>
              <td>锌层</td>
              <td>重量（吨）</td>
              <td>车号</td>
              <td>合同号</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in goodList" :key="item.id">
              <td>{{item.cargoBarcode}}</td>
              <td>{{item.model}}</td>
              <td>{{item.specification}}</td>
              <td>{{item.surfaceQuality}}</td>
              <td>{{item.zincCoating}}</td>
              <td>{{item.weight}}</td>
              <td>{{item.vhcNo}}</td>
              <td>{{item.contractNumber}}</td>
            </tr>
            <tr>
              <td>合计</td>
             <td colspan="3">{{billData.productNum}}件</td>
              <td colspan="4">{{billData.allWeight}}吨</td>
            </tr>
          </tbody>
        </table>
        <div v-if="carriageList.length>0">
           <h5>提货人、车明细：</h5>
          <table border="1" cellpadding="0" cellspacing="0" >
            <thead>
              <tr>
                <td>提货车号</td>
                <td>提货单位/人</td>
                <td>纳税人识别号/身份证号</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in carriageList" :key="item.id">
              <td>{{item.vhcNo}}</td>
              <td>{{item.driverName}}</td>
              <td>{{item.driverIdentityNo}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <div class="footer">
            <div>制单人：{{billData.createUserName}}</div>
            <div>制单时间：{{billData.createTime|dateFormat}}</div>
          </div>
          <div class="footer">
            <div>{{billData.deliverCompany}}</div>
            <div>生效日期：{{billData.createTime|dateFormat1}}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTHH = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 转货-->
    <el-dialog  title="转货"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"  @close="closeDialog"  :visible.sync="ZHdialog" width="400px" center>
         <el-form :inline="true" :rules="rules" :model="HTfrom" ref="HTfrom" class="demo-form-inline" label-width="120px" size="mini" border>
        <div class="inpBox">

          <el-form-item label="新客户名称:" prop="newCustomerName">
            <el-select v-model="HTfrom.newCustomer"  filterable remote placeholder="请输入关键词" allow-create default-first-option
              :remote-method="xkhmcFn" value-key="custerCode" :loading="loading1">
              <el-option v-for="item in customerList" :key="item.custerCode" :label="item.custerName" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
         <el-button @click="ZHdialog = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('HTfrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-drawer title="编辑" @close="closeDialog"  direction="ltr" size="49%"  :visible.sync="editMark">
      <div>
           <div class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes" aria-hidden="true"></i>基本信息</span>
          </h4>
        </div>

         <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini">
        <div>
          <el-form-item label="提货仓库:"   >
              <div style="min-width:260px">{{billData.organizationName}}</div>
          </el-form-item>
           <el-form-item label="提货单号:"  >
              <div style="min-width:260px">{{billData.billNo}}</div>
          </el-form-item>
        </div>
        <div>
            <el-form-item label="出库单号:" v-if="tableArr[0]" >
              <div style="min-width:260px">{{billData.outBillNo}}</div>
            </el-form-item>
            <el-form-item label="业务单号:"  >
                <div style="min-width:260px">{{billData.businessNo}}</div>
            </el-form-item>
        </div>

          <el-form-item label="提货方式:" prop="isEntrust" >
              <template >
              <el-radio-group v-model="addFrom.isEntrust"    @change="isEntrustChange" >
                <el-radio :label="1">委托</el-radio>
                <el-radio :label="2" >自提</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
           <el-form-item label="提货单位:"  prop="pickUpUnit"    >
               <el-input  :class="{disabled:addFrom.isEntrust==2}" maxlength="20" :readonly="addFrom.isEntrust==2?true:false"  v-model="addFrom.pickUpUnit"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:" prop="feeMode" v-if="!jsfsDIsable&&jsfsFlag"  >
              <el-select v-model="addFrom.feeMode" placeholder="请选择" value-key="item_no" >
                <el-option v-for="item in jsfsList" :key="item.item_no" :label="item.show_name" :value="item" ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="结算方式:" prop=""   v-if="jsfsDIsable&&jsfsFlag"   >
              <div  style="wdith:150px">{{["现结", "月结"][row.feeModeType-1]}}</div>
          </el-form-item>

        <hr>
         <div class="addressBox" >
        <h4 class="title">
          <span><i class="fa fa-truck" aria-hidden="true"></i>人车信息</span>
           <el-form-item style="margin-left:16px">
             <el-button type="primary" @click="addRCFn">新增</el-button>
          </el-form-item>
        </h4>
      </div>
       <el-table :data="addFrom.carriageInfos"  ref="table"   bordersize="mini"    style="width: 100%" height="500"   center border>
         <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="300">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.vhcNo'" :key="scope.$index" :rules="rules.vhcNo">
                <el-input  placeholder="请输入提货车号"  type="textarea"    maxlength="200"     v-model="addFrom.carriageInfos[scope.$index].vhcNo"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="提货单位/人" width="170">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName">
                <el-input  placeholder="请输入提货单位/人"  type="textarea"  maxlength="100"     v-model="addFrom.carriageInfos[scope.$index].driverName"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="纳税人识别号/身份证号" min-width="170">
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.driverIdentityNo'" :key="scope.$index" :rules="rules.driverIdentityNo">
                <el-input  placeholder="请输入纳税人识别号/身份证号" type="textarea"  maxlength="30"     v-model="addFrom.carriageInfos[scope.$index].driverIdentityNo"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <div>
            <el-button type="text" size="mini"   @click="delRCFn(scope.row,scope.$index)">删除</el-button>
              </div>
          </template>
        </el-table-column>
       </el-table>
         </el-form>
      </div>
      <el-drawer title="货物信息" size="100%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible.sync="editMark" >
       <div style="padding-top: 20px;">
         <el-form :inline="true" :model="HWsearchFrom" ref="HWsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
                <div >
                  <!-- <el-form-item label="货物总重量:" prop="">
                    <span>{{billData.spillSBillWeight}}吨</span>
                  </el-form-item>
                  <el-form-item label="已选货物重量:" prop="" v-if="billData.parentId==0">
                    <span>{{yxWeight}}吨</span>
                  </el-form-item> -->
                      <!-- <el-form-item >
                    <el-button type="primary" @click="HWsearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="resetForm()">重置</el-button>
                  </el-form-item> -->
                </div>
          </el-form>
          <div :style="{height:h}">
            <el-table :data="goodList" ref="goodTable"  bordersize="mini" class="table" center border height="92%"
             @selection-change='selectGoods'  @row-click="handleRowClick1">
               <!-- <el-table-column type="selection" width="55" v-if="billData.parentId==0"></el-table-column> -->
                <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
               <el-table-column property="cargoBarcode" width="150" label="捆包号"></el-table-column>
                 <el-table-column property="weight"  width="100" label="重量(吨)"></el-table-column>
                <el-table-column property="model" width="120" label="材质"></el-table-column>
                <el-table-column property="specification" width="120"  label="规格"></el-table-column>
                 <el-table-column property="surfaceQuality" width="120" :formatter="emptyFn"   label="表面质量"></el-table-column>
                  <el-table-column property="zincCoating" width="120" :formatter="emptyFn"   label="锌层"></el-table-column>
                 <el-table-column property="vhcNo" width="130"  label="车号"></el-table-column>
                <el-table-column property="contractNumber" width="120"  label="合同号"></el-table-column>
            </el-table>
            <!-- <div style="padding-left:10px;color:red">
              <p style="margin:8px 0">备注：未拆分的大提单，可勾选部分货物拆单或不勾选货物不拆单提交或暂存；</p>
              <p style="margin:0;text-indent:3em">拆分过的大提单，必须选择货物才能提交或暂存</p>
            </div> -->
          </div>
       </div>
       <div class="btnBox">
          <el-button type="primary" @click="THsaveFn(1)">暂存</el-button>
           <el-button type="primary" @click="THsaveFn(2)">提货</el-button>
        </div>
      </el-drawer>
  </el-drawer>
   <!-- 撤回 -->
    <el-dialog  title="撤回"  :visible.sync="dialogCH" width="460px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true" :rules="rules" :model="CHFrom" ref="CHFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
            <el-form-item label="撤回原因:" prop="reason" class="miaoshu">
              <el-input  type="textarea" :rows="3"  placeholder="" maxlength="100" v-model="CHFrom.reason"></el-input>
            </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCH = false">取 消</el-button>
        <el-button type="primary" @click="CHsave()">确 定</el-button>
      </span>
   </el-dialog>
    <!-- 人车 -->
    <renChe  :row-data="addFrom" v-if="rencheFlag" @destroy="destroy"></renChe>
 </div>
</template>

<script>
import { getBtn, getAttribute } from '@/utils/getButton'
import { sBillList, submitApproval, sBillCarriageInfoDel,
  sBillCarriageInfoList, delBill, getSBillFileUrl, goodsDetail, getCustomerlistByTenant, billTransferGoods,
  saveOrUpdateBill, getDictionaryDetail, feeModeType, sBillRecallBill } from '@/api/soc-stock'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import renChe from '@/views/soc-stock/takeGoodsBill/renChe.vue'
export default {
  components: {
    renChe
  },
  data () {
    return {
      tableArr: [],
      // detailArr: [],
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      tableList: [],
      loading: 'false',
      dialogTHH: false, // 提货函
      isEdits: [],
      dialogRC: false,
      ZHdialog: false, // 转货
      addFrom: { isEntrust: 1, carriageInfos: [] },
      rules: {
        newCustomer: [
          { required: true, message: '请输入新客户名称', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请输入提货车号', trigger: 'blur' }
        ],
        driverName: [
          { required: true, message: '请输入提货单位/人', trigger: 'blur' }
        ],
        driverIdentityNo: [
          { required: true, message: '请输入纳税人识别号/身份证号', trigger: 'blur' }
        ],
        pickUpUnit: [
          { required: true, message: '请输入提货单位', trigger: 'blur' }
        ],
        isEntrust: [
          { required: true, message: '请选择自提方式', trigger: 'blur' }
        ],
        feeMode: [
          { required: true, message: '请选择结算方式', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '请输入撤回原因', trigger: 'blur' }
        ]
      },
      row: {},
      carriageList: [],
      goodList: [],
      billData: {},
      yxWeight: 0,
      loading1: false, // 新客户名称下拉
      customerList: [],
      HTfrom: {},
      editMark: false,
      selectGoodArr: [],
      HWsearchFrom: {},
      maps: new Map(),
      symbolKey: '',
      jsfsFlag: false,
      jsfsDIsable: false,
      jsfsList: [],
      dialogCH: false, // 撤回
      CHFrom: {},
      rencheFlag: false,
      isCutCrm3: localStorage.getItem('isCutCrm3'),
      btnFlg: [],
      btnIdArr: ['004P00EB001', '004P00EB002', '004P00EB003', '004P00EB004',
        '004P00EB005', '004P00EB006', '004P00EB007', '004P00EB008']
    }
  },
  created () {
    this.tableArr = getAttribute('ARRshiOutBillNo')
    this.btnFlg = getBtn(this.btnIdArr, '/StakeGoodsBill')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.$set(this.searchFrom, 'organizationId', localStorage.getItem('createTenantCode'))
    }
    this.getList(this.searchFrom)
    feeModeType().then(res => {
      this.jsfsList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 人车
    rencheFn (row) {
      this.addFrom.id = row.id
      this.addFrom.janFaFlag = false
      this.rencheFlag = true
    },
    destroy () {
      this.rencheFlag = false
    },
    load (tree, treeNode, resolve) {
      sBillList({ billId: tree.id }).then(res => {
        this.maps.set(tree.id, { tree, treeNode, resolve })
        resolve(res.list)
      })
    },
    editFN (row) {
      this.row = row
      this.editMark = true
      goodsDetail({ id: row.id }).then(res => {
        this.goodList = res.goodsList
        this.billData = res.sBill
        this.billData.spillSBillWeight = res.spillSBillWeight
        if (res.sBill.isEntrust) {
          this.$set(this.addFrom, 'isEntrust', res.sBill.isEntrust)
        } else {
          this.$set(this.addFrom, 'isEntrust', 1)
        }
        this.carriageList = res.carriageList
        this.$set(this.addFrom, 'pickUpUnit', res.sBill.pickUpUnit)
        this.$set(this.addFrom, 'carriageInfos', res.carriageList)
      })
      getDictionaryDetail({
        groupNo: 'settlement_flag',
        itemNo: row.organizationId
      }).then(res => {
        if (res.length > 0) {
          this.jsfsFlag = true
        } else {
          this.jsfsFlag = false
        }
        if (row.feeModeType) {
          this.jsfsDIsable = true
          this.$set(this.addFrom, 'feeModeType', row.feeModeType)
          this.$set(this.addFrom, 'feeModeTypeName', row.feeModeTypeName)
        } else {
          this.jsfsDIsable = false
        }
      })
      this.addFrom.id = row.id
      this.selectGoodArr = []
    },
    // 选择货物数据
    selectGoods (selection) {
      this.selectGoodArr = []
      let weight = 0
      selection.forEach(item => {
        this.selectGoodArr.push(item.cargoBarcode)
        weight = (weight * 1000 + item.weight * 1000) / 1000
      })
      this.yxWeight = weight.toFixed(3)
    },
    // 页面得提货保存
    THsaveFn (n) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          // if (this.billData.isSplit == 2 && this.selectGoodArr.length == 0) {
          //   this.$alert('请选择要拆单得货物', '系统提示')
          //   return
          // }
          this.addFrom.submitStatus = n
          this.addFrom.cargoBarcodes = this.selectGoodArr.toString()
          if (this.addFrom.feeMode) {
            this.addFrom.feeModeType = this.addFrom.feeMode.item_no
            this.addFrom.feeModeTypeName = this.addFrom.feeMode.show_name
          }
          if (n == 1) {
            this.jiekouFn()
          } else {
            let tishiyu = ''
            if (this.addFrom.carriageInfos.length == 0) {
              tishiyu = ' 没有添加司机、车辆信息，是否继续提交？'
            } else {
              tishiyu = '是否执行提交操作？'
            }
            this.$confirm(tishiyu, '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              this.jiekouFn()
            }).catch(() => {

            })
          }
        }
      })
    },
    jiekouFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      saveOrUpdateBill(this.addFrom).then(res => {
        loading.close()
        this.getList(this.searchFrom)
        this.editMark = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          duration: 0,
          onClose () {
            loading.close()
          }
        })
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.parentId != 0) {
        return 'ziji'
      } else {
      }
    },
    // 是否委托提货
    isEntrustChange () {
      if (this.addFrom.isEntrust == 1) {
        this.$set(this.addFrom, 'pickUpUnit', '')
      } else {
        this.$set(this.addFrom, 'pickUpUnit', this.billData.tenantName)
      }
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 转货
    zhuanhuoFn (row) {
      this.ZHdialog = true
      this.HTfrom.billId = row.id
      this.row = row
    },
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        nameLike: query,
        tenantCode: this.row.organizationId
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    // 转货确认
    saveFn () {
      this.$refs.HTfrom.validate((valid) => {
        if (valid) {
          if (typeof (this.HTfrom.newCustomer) == 'string') {
            this.HTfrom.newCustomerName = this.HTfrom.newCustomer
            this.HTfrom.newCustomerTaxId = ''
            this.HTfrom.newCustomerId = ''
          } else {
            if (this.HTfrom.newCustomer.custerCode == '') {
              this.HTfrom.newCustomer = null
            } else {
              this.HTfrom.newCustomerTaxId = this.HTfrom.newCustomer.taxpayerNumber
              this.HTfrom.newCustomerId = this.HTfrom.newCustomer.custerCode
              this.HTfrom.newCustomerName = this.HTfrom.newCustomer.custerName
            }
          }
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          billTransferGoods(this.HTfrom).then(res => {
            loading.close()
            this.$router.push({ name: 'transferGoods' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 提交审批
    submitFn (row) {
      if ((row.isEntrust && row.pickUpUnit)) {
        sBillCarriageInfoList({ billId: row.id, billCategory: 1 }).then(res => {
          let tishiyu = ''
          if (res.length == 0) {
            tishiyu = ' 没有添加司机、车辆信息，是否继续提交？'
          } else {
            tishiyu = '是否执行提交操作？'
          }
          this.$confirm(tishiyu, '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            submitApproval({ id: row.id }).then(res => {
              loading.close()
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
              this.dialogTHH = false
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {
            if (tishiyu != '是否执行提交操作？') {
              this.editFN(row)
            }
          })
        })
      } else {
        this.$alert('没有添加提货单位，请点击【编辑】按钮或点击当前【确定】按钮进行添加！', '系统提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.editFN(row)
          }
        })
      }
    },
    // 撤回
    recallFn (row) {
      this.dialogCH = true
      this.CHFrom.id = row.id
    },
    CHsave () {
      this.$refs.CHFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sBillRecallBill(this.CHFrom).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            loading.close()
            this.dialogCH = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 发布
    publishFn (row) {
      this.$router.push({ name: 'StakeGoodsBillRelease', query: { id: row.id } })
    },
    // 查看提货函
    lookFn (row) {
      if (row.fileUrl) {
        let formData = new FormData()
        formData.append('url', row.fileUrl)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      } else {
        goodsDetail({ id: row.id }).then(res => {
          this.goodList = res.goodsList
          this.billData = res.sBill
          this.carriageList = res.carriageList
          // if (res.extAttritude) {
          //   this.detailArr = JSON.parse(res.extAttritude)
          // }
        })
        this.dialogTHH = true
      }
    },

    // 添加人车信息
    addRCFn () {
      // if (!this.isEdits.every(item => { return !item })) {
      //   this.$alert('页面有未保存的人车信息，请先处理', '系统提示')
      // } else {
      //   this.RCFrom.RClist.push({ key: this.RCFrom.RClist.length })
      //   this.isEdits.push(true)
      // }
      this.addFrom.carriageInfos.push({})
    },
    // 删除人车
    delRCFn (row, index) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (row.id) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sBillCarriageInfoDel({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.addFrom.carriageInfos.splice(index, 1)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.addFrom.carriageInfos.splice(index, 1)
        }
      }).catch(() => {

      })
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'StakeGoodsBillDetails', query: { id: row.id } })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },

    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    handleRowClick1 (row, column, event) {
      // this.$refs.goodTable.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sBillList(searchFrom).then(res => {
        this.loading = false
        this.symbolKey = Symbol(new Date().toString())
        this.tableList = res.list
        this.tableList.forEach((item, index) => {
          this.tableList[index].parentIndex = index + 1
          if (item.isSplit == 2) {
            this.tableList[index].hasChildren = true
          } else {
            this.tableList[index].hasChildren = false
          }
          if (this.maps.get(item.id)) {
            const { tree, treeNode, resolve } = this.maps.get(item.id)
            this.load(item, treeNode, resolve)
          }
        })
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      if (localStorage.getItem('isCutCrm3') == 1) {
        this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].tenantCode)
      }
    },

    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        // let formData = new FormData()
        // formData.append('id', row.id)
        delBill({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.HTfrom = {}
      this.addFrom = { isEntrust: 1, carriageInfos: [] }
      this.selectGoodArr = []
      this.$refs.table.clearSelection()
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      if (row.parentId == 0 && row.isSplit == 2) {
        switch (cellValue) {
          case 1001:
            return '拆分中'
          case 1021:
            return '下发失败'
          case 1031:
            return '待提货'
          case 1041:
            return '提货中'
          case 1042:
            return '提货完成'
        }
      } else {
        switch (cellValue) {
          case 1001:
            return '待提交'
          case 1011:
            return '审批中'
          case 1012:
            return '审批驳回'
          case 1021:
            return '下发失败'
          case 1031:
            return '待提货'
          case 1041:
            return '提货中'
          case 1042:
            return '提货完成'
        }
      }
    }
  }
}
</script>

<style scoped lang='less'>
.tihuohan{
  color: #000;
  h3{
    text-align: center;
    margin: 0;
  }
  .Q0101{
    flex-direction: column;
  }
  .Q0101 li{
    display: flex;
    justify-content: space-between;
  }
  ul{
    display: flex;
    justify-content: space-between;
  }
  table{
    width: 100%;
    td{
      padding: 4px 10px;
      text-align: center;
    }
  }
  .footer{
    margin-top: 20px;
  }
}
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
/deep/.el-table .el-form-item{
  width: 100%;
}
/deep/.el-table .el-form-item__content{
   width: 100%;
}
.btnBox{
  text-align: center;
  margin-top: 20px;
  .el-button{
        padding: 15px 25px;
        margin-top: 20px;
  }
}
/deep/.el-table .ziji {
   background: #d7ebfb !important;
}
</style>
